import type { JSX } from 'react'
import type { IAvatarProps } from '../Avatar'
import type { AvatarColors } from '../Avatar.h'

import { getAvatarColor } from 'utils/helpers'
import { Avatar } from '../Avatar'
import { AvatarBorders, AvatarFonts, AvatarProfileColorList } from '../Avatar.h'

export const AvatarProfile = ({
  title = '',
  width = 116,
  height = 116,
  font = AvatarFonts.Headline3,
  borders = AvatarBorders.BORDER_0,
  ...rest
}: IAvatarProps): JSX.Element => {
  const backgroundDefault = getAvatarColor(
    title,
    AvatarProfileColorList
  ) as AvatarColors

  return (
    <Avatar
      {...rest}
      title={title}
      width={width}
      height={height}
      font={font}
      borders={borders}
      backgroundDefault={backgroundDefault}
    />
  )
}
